/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const u = {
  before: "before",
  after: "after",
  forbidden: "forbidden"
};
function e(o) {
  const { clientTop: t, clientLeft: f } = d(o), { pageYOffset: c, pageXOffset: n } = s(o), { top: r, left: i } = o.getBoundingClientRect();
  return {
    top: r + c - t,
    left: i + n - f
  };
}
const d = (o) => o == null ? void 0 : o.ownerDocument.documentElement, s = (o) => o == null ? void 0 : o.ownerDocument.defaultView;
export {
  u as dropDirection,
  e as getOffset
};
